import(/* webpackMode: "eager" */ "/home/runner/work/MONADATY/MONADATY/app/shop/error.tsx");
